import {BaseDtoModel} from '../../Services/Models/base-model.service';

export class CommunicationFilters extends BaseDtoModel {
  id_local!: number;
  id_tipo!: number[];
  familia_averia!: number;
  cerradas!: boolean;
  ordenar!: string;
  ordenar_direccion!: 'asc' | 'desc';
  todas!: number;

  constructor(dataJson?: any) {
    super(dataJson);

    this.init({
      id_local: 0,
      id_tipo: [],
      familia_averia: 0,
      cerradas: false,
      ordenar: 'not',
      ordenar_direccion: 'desc',
      todas: 1,
    });
  }
}
